var Egg = function () {

	var toMatch = [
		{
			'searchRegexp': /^comic ?sans/i,
			'fx': function () {
				$('*').css('font-family', 'Comic Sans MS');
			}
		},
		{
			'searchRegexp': /^australia/i,
			'fx': function () {
				$('body').css('transform', 'rotate(180deg)');
			}
		},
		{
			'searchRegexp': /^ninja/i,
			'fx': function () {
				$('body').css('background', '#000').css('opacity', '0.15');
			}
		},
		{
			'searchRegexp': /^papar[aá]da/i,
			'youtube': 'ZS0EZJzwdOs'
			// 'youtube': 'KGPVsaXZA6c' zabanovano?!
		},
		{
			'searchRegexp': /^(nebudu to delat|nebudu to dělat)/i,
			'youtube': 'SiUz_akTmcY'
		},
		{
			'searchRegexp': /^allahu akbar/i,
			'youtube': 'fW_FtTaE0hE'
		},
		{
			'searchRegexp': /^(ze zivota ajtaka|ze života ajťáka|zivot ajtaka|život ajťáka)/i,
			'youtube': 'dn0_UlH1kVI'
		},
		{
			'searchRegexp': /^1337/i,
			'fx': function () {
				$('body *').each(function(){
					if ($(this).children().length==0) {
						var txt = $(this).text();
						var fr = ['eéEÉěĚ','lL', 'tTťŤ','oóOÓ','sšSŠ', 'aá'];
						var to = ['3','1','7','0','5', '4'];
						for (var i=0; i<fr.length; i++) {
							var reg = new RegExp('[' + fr[i] + ']', 'g')
							txt = txt.replace(reg, to[i]);
						}
						$(this).html(txt);
					}
				});
			}
		},
		{
			'searchRegexp': /^(oldschool|stara skola|stará škola)/i,
			'fx': function () {
				oldschool.set(2016);
			}
		},
	];

	var oldschool = {
		activated: false,
		current: 0,
		possible: [2016, 2011, 2010, 2007],
		set: function(year) {
			if (oldschool.activated === false) {
				var oldschoolNav = $('<ul id="oldschool-nav" class="oldschool-nav"></ul>');
				oldschool.possible.forEach(function(y){
					var li = $('<li data-year="' + y + '">' + y + '</li>').bind('click', function(){
						oldschool.set($(this).data('year'));
					});
					oldschoolNav.append(li);
				});
				var oldschoolBody = $('<div id="oldschool-body" class="oldschool-body"></div>');
				$('body')
					.append(oldschoolBody)
					.append(oldschoolNav);
			} else {
				var oldschoolBody = $('#oldschool-body');
				var oldschoolNav = $('#oldschool-nav');
			}

			oldschoolBody
				.removeClass('oldschool-body-' + oldschool.current)
				.addClass('oldschool-body-' + year)
				.height($(document).height());

			oldschoolNav.find('li').removeClass('active');
			oldschoolNav.find('[data-year="' + year + '"]').addClass('active');

			oldschool.current = year;
			oldschool.activated = true;
		}
	};

	var youtube = function(id) {
		if ($('#vtipesek').length>0) return false;
		var video = $('<iframe id="vtipesek" width="640" height="360" style="width:640px; height:360px; position:fixed; z-index:10000; top:0; left:0; bottom:0; right:0; margin:auto;" src="https://www.youtube.com/embed/' + id + '?autoplay=1" frameborder="0" allowfullscreen></iframe>');
		$('body').append(video);
		$('main,header,footer').css('opacity', '0.15');
	};

	var toMatchSearch = toMatch.filter(function(egg){
		return typeof egg.searchRegexp !== 'undefined';
	});

	var init = function () {
		var searchField = $('#search');
		searchField.bind('keyup', function() {
			var searchValue = $(this).val();
			toMatchSearch.forEach(function(egg){
				if (egg.searchRegexp.exec(searchValue) !== null) {
					$(this).val('EASTER EGG ACTIVATED!');
					if (typeof egg.youtube !== 'undefined') {
						youtube(egg.youtube);
					} else if (typeof egg.fx !== 'undefined') {
						egg.fx();
					}
				}
			});
		});

	};

	return {
		init: init
	};
}();

UL.register(Egg);
